import React, { useEffect } from "react"
import { firestoreConnect, isLoaded } from "react-redux-firebase"
import Presentation from "./Presentation"
import { compose } from "redux"
import { connect } from "react-redux"
function Container(props) {
  const { comments } = props
  const [state, setState] = React.useState({
    comments: [],
  })
  useEffect(() => {
    isLoaded(comments)
  }, [comments])
  if (isLoaded(props.project, props.tasktimeline))
    return (
      <div>
        <Presentation {...props}  />
      </div>
    )
  return <p>Loading</p>
}

const mapStateToProps = (state, ownProps) => {
  return {
    // taskslist: state.firestore.ordered.taskslist,
    projectId: ownProps.match.params.projectId,
    taskId: ownProps.match.params.taskId,
    project: state.firestore.ordered.project,
    tasktimeline: state.firestore.ordered.tasktimeline,
    names: state.firestore.ordered.names,
    employee: state.firebase.profile,
  }
}
export default compose(
  connect(mapStateToProps),
  firestoreConnect((props) => {
    if (!props.project || !props.tasktimeline)
      return [
        {
          collection: "PROJECTS",
          doc: props.match.params.projectId,
          storeAs: "project",
        },
        {
          collection: "PROJECTS",
          doc: props.match.params.projectId,
          subcollections: [
            {
              collection: "TASKS",
              doc: props.match.params.taskId,
              subcollections: [
                {
                  collection: "TASK_TIMELINE",
                  storeAs: "tasktimeline",
                },
              ],
              storeAs: "tasktimeline",
            },
          ],
          storeAs: "tasktimeline",
        },
      ]
    return []
  })
)(Container)
